import { Component } from '@angular/core';
import { OnlinekeyCardModel } from './onlinekey-card.model';

@Component({
  selector: 'app-detail-table',
  templateUrl: './onlinekey-card-table.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})
export class OnlineKeyTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: OnlinekeyCardModel[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }
}
